'use client';

import { useEffect } from 'react';
import Lenis from 'lenis';
import { gsap, ScrollTrigger } from '@/lib/gsapSetup';

let lenis = null;

export default function SmoothScroll() {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const isMobile = window.matchMedia('(max-width: 992px)').matches;
    if (isMobile) return;

    // Initialize Lenis
    lenis = new Lenis({
      duration: 1.5,
      smooth: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothTouch: false,
      syncTouch: true,
      touchInertiaMultiplier: 2.5,
      wheelMultiplier: 1.2,
      lerp: 0.1,
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      normalizeWheel: true,
      fps: 60,
    });

    // Ensure Lenis scrolls to the correct position after reload
    lenis.on('scroll', () => {
      gsap.ticker.add(() => ScrollTrigger.update()); // Uses GSAP's optimized tick system
    });

    // Use GSAP's ticker for smoother performance
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    // Update ScrollTrigger on scroll
    lenis.on('scroll', ScrollTrigger.update);

    // Refresh ScrollTrigger after a delay to avoid stuttering
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    // Disable GSAP lag smoothing
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(() => lenis.raf);
      lenis.destroy();
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return null;
}

export { lenis };
